import React, { useEffect } from 'react'
import styles from './statistic-modal.module.scss'
import { confirm } from '../../UI/Confirm/Confirm.js'
import Socket from '../../websocket/index.js'

export default function SendStatisticStepTwo({ onExploreServices, onSkip }) {
  useEffect(() => {
    return () => {
      Socket.emit('seafarer_survey.select_vacancy', { vacancy_id: null })
    }
  }, [])
  const isUserEditingProfile = () => {
    const currentPath = window.location.pathname

    const isOnProfileEditPage = currentPath.includes('/profile/edit/')

    if (!isOnProfileEditPage) {
      return false
    }

    const activeElement = document.activeElement
    if (
      activeElement &&
      (activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true')
    ) {
      return true
    }

    const changedInputs = document.querySelectorAll(
      'input.changed, input[data-changed="true"], textarea.changed, textarea[data-changed="true"]'
    )
    const dirtyInputs = document.querySelectorAll(
      'input.dirty, input[data-dirty="true"], textarea.dirty, textarea[data-dirty="true"]'
    )
    const modifiedInputs = document.querySelectorAll('input.modified, textarea.modified, [data-modified="true"]')

    const saveButtons = document.querySelectorAll(
      'button[type="submit"]:not(:disabled), .save-button:not(:disabled), .submit-button:not(:disabled)'
    )
    const enabledSaveButtons = Array.from(saveButtons).filter(
      (btn) => btn.style.display !== 'none' && !btn.hasAttribute('disabled')
    )

    return (
      changedInputs.length > 0 || dirtyInputs.length > 0 || modifiedInputs.length > 0 || enabledSaveButtons.length > 0
    )
  }

  const handleExploreServices = () => {
    const isEditing = isUserEditingProfile()

    if (isEditing) {
      if (document.getElementById('confirm')) {
        return
      }

      confirm(
        'Are you sure you want to proceed?',
        'You have unfinished business.',
        () => {
          onExploreServices()
        },
        () => {
          return
        }
      )
    } else {
      onExploreServices()
    }
  }

  useEffect(() => {
    return () => {
      Socket.emit('seafarer_survey.select_vacancy', { vacancy_id: null })
    }
  }, [])
  return (
    <>
      <div className={styles['statisticStepTwo']}>
        <b>🚀 Check Out Our Career Boosting Services!</b>
        <p>Looking for a job? Maximize your chances with our exclusive tools! 🔥</p>
        <ul>
          <li>✅ Get VIP visibility in employer searches</li>
          <li>✅ Track who’s interested in your profile</li>
          <li>✅ Receive early access to new job postings</li>
          <li>✅ Stand out with a personalized status</li>
        </ul>

        <p>🎯 Invest in your future today! Visit our service store and give your maritime career a powerful boost.</p>
        <div className={`${styles['statisticStep__buttons']} ${styles['statisticStep__buttons_column']}`}>
          <button onClick={handleExploreServices} className={styles['statisticStep__button']}>
            Explore services
          </button>
          <button onClick={onSkip} className={styles['statisticStep__button']}>
            Skip
          </button>
        </div>
      </div>
    </>
  )
}
